import { Center, Spinner } from '@chakra-ui/react'

export const PageSpinner = () => {
    return (
        <Center minH='100dvh' w='full'>
            <Spinner color='mistySage.500' size='lg' />
        </Center>
    )
}
